import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-big-chevron-right',
  templateUrl: './icon-big-chevron-right.component.html',
  styleUrls: ['./icon-big-chevron-right.component.scss']
})
export class IconBigChevronRightComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
